import React from 'react';

const PrintingIndicators = ({ printingBulletin, printingAll, bulletinsCount }) => {
  return (
    <>
      {/* Indicateur d'impression individuelle */}
      {printingBulletin && (
        <div className="mb-6 p-4 bg-blue-50 border border-blue-200 rounded-lg">
          <div className="flex items-center justify-center">
            <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-blue-600 mr-3"></div>
            <span className="text-blue-700 font-medium">
              Préparation de l'impression du bulletin...
            </span>
          </div>
        </div>
      )}
      
      {/* Indicateur d'impression globale */}
      {printingAll && (
        <div className="mb-6 p-4 bg-green-50 border border-green-200 rounded-lg">
          <div className="flex items-center justify-center">
            <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-green-600 mr-3"></div>
            <span className="text-green-700 font-medium">
              Préparation de l'impression de tous les bulletins ({bulletinsCount || 0} bulletin(s))...
            </span>
          </div>
        </div>
      )}
    </>
  );
};

export default PrintingIndicators;
